<div class="ss-theme-toggle" role="radiogroup" aria-label="Tema" (keydown)="onKeydown($event)">
  <button
    *ngFor="let option of options"
    type="button"
    role="radio"
    class="ss-theme-toggle__option"
    [class.is-active]="themeService.theme === option.theme"
    [attr.aria-checked]="themeService.theme === option.theme"
    [attr.tabindex]="themeService.theme === option.theme ? 0 : -1"
    [attr.aria-label]="option.label"
    [title]="option.label"
    (click)="select(option.theme)">
    <lucide-icon [name]="option.icon" [size]="16" [strokeWidth]="2.2" aria-hidden="true"></lucide-icon>
  </button>
</div>
